/**
 * This module contains the deprecated [[Resolve]] helper view.
 * Don't use&mdash;use the facilities in the [["core/setup/register"]] module and plain data binding instead.
 */

/***/

import View from '../core/view/View';
import { node } from '../core/node/Node';

/**
 * Deprecated. Your models no longer need to implement `getViewName()`. Simply create a view
 * registration for the model constructor, then in templates resolve using `view="[[someData]]"`.
 *
 * @deprecated Use the facilities provided by the `core/setup/register` module instead.
 */
export interface Resolvable {
	/**
	 * Returns a registration name of the `View` class that should be used for this object.
	 */
	getViewName(): string;
}

function isResolvable(data: any): data is Resolvable {
	return data && typeof data.getViewName !== 'undefined';
}

/**
 * @deprecated Use the facilities provided by the `core/setup/register` module instead.
 *
 * @example
 *```
 * import register from '.../core/setup/register';
 *
 * const {viewRegistrations} = register(({model, view}) => {
 *     view('App', AppView);
 *     model('App\\Image', Image).view(ImageView);
 *     ...
 * });
 * scan(document.body, viewRegistrations);
 *```
 */
export class Resolve extends View {

	public constructor() {
		super({ template: '<div></div>' });
	}

	public get data(): Resolvable {
		return this._data;
	}

	public set data(value: Resolvable) {
		if (!value) return;
		const previousValue = this._data;
		this._data = value;
		if (value !== previousValue) {
			this.update();
		}
	}

	protected init() {
		this.update();
	}

	public update(name?: string) {
		if (!this.node) return;
		if (name) {
			super.update(name);
			return;
		}
		const viewName = isResolvable(this._data) ? this._data.getViewName() : 'default';
		const view: View = this.createChild( viewName );
		if (view) {
			view.data = this._data;
			view.render();
			node( this.node ).empty();
			this.node.appendChild(view.node);
		}
	}
}


export default Resolve;
